import {
    AwesomeTableComponent,
    HeaderTable,
    IColumnsProps,
    TimeUtils,
    ViewLabelStatus,
} from "d-react-components";
import { debounce } from "lodash";
import { useRef } from "react";
import { generatePath, useHistory } from "react-router-dom";
import NewsAPI from "../../../api/news/NewsAPI";
import AppLink from "../../../common/AppLink";
import Image from "../../../common/Image";
import TableAction from "../../../common/TableActions";
import { CATEGORY_STATUSES } from "../../../constant/category";
import { INews } from "../../../interfaces/news";
import Messages from "../../../languages/Messages";
import Path from "../../Path";

const NewsTable = () => {
    const tableRef = useRef<any>(null);
    const searchRef = useRef<string>("");
    const history = useHistory();
    const columns: IColumnsProps = [
        {
            title: Messages.id,
            dataIndex: "newsId",
            render: (newsId, item) => (
                <AppLink
                    to={generatePath(Path.NEWS_DETAIL, {
                        newsId: item.id,
                    })}
                    className="p-3"
                >
                    {newsId}
                </AppLink>
            ),
        },
        {
            title: Messages.feature,
            dataIndex: "featuredUrl",
            render: (featuredUrl) => (
                <Image src={featuredUrl} className="image-square-small" />
            ),
        },

        {
            title: Messages.title,
            dataIndex: Messages.getLanguage(),
            render: (info) => info?.title,
        },

        {
            title: Messages.status,
            dataIndex: "status",
            render: (status) => (
                <ViewLabelStatus
                    status={status}
                    listStatus={CATEGORY_STATUSES}
                />
            ),
        },

        {
            title: Messages.createdBy,
            dataIndex: "createBy",
            render: (by) => by?.firstName,
        },

        {
            title: Messages.createAt,
            dataIndex: "createdAt",
            render: TimeUtils.toDate,
        },
        {
            title: Messages.action,
            dataIndex: "",
            align: "center",
            render: (news: INews) => {
                return (
                    <TableAction
                        onClick={(actionId: string) =>
                            onClickTableAction(actionId, news)
                        }
                    />
                );
            },
        },
    ];

    const source = (pagingData: any) => {
        return NewsAPI.list(searchRef.current, pagingData);
    };

    const onClickTableAction = (actionId: string, news: INews) => {
        switch (actionId) {
            default:
                history.push(
                    generatePath(Path.NEWS_DETAIL, {
                        newsId: news.id,
                    })
                );
        }
    };

    const onClickAddNew = () => {
        history.push(Path.NEWS_CREATE);
    };

    const onChangeSearch = debounce((text) => {
        searchRef.current = text;
        tableRef.current.refresh();
    }, 500);

    return (
        <div className="p-4">
            <HeaderTable
                onClickNew={onClickAddNew}
                label={Messages.allNews}
                // onClickFilter={() => {}}
                onChangeText={(event: any) =>
                    onChangeSearch(event.target.value)
                }
                className="mb-3"
            />
            <AwesomeTableComponent
                ref={(ref) => {
                    tableRef.current = ref;
                }}
                source={source}
                transformer={(res) => {
                    return res?.data?.data?.news ?? [];
                }}
                columns={columns}
                showSelectColumn
                baseColumnProps={{ width: 200 }}
            />
        </div>
    );
};

export default NewsTable;
